<template>
  <div>
    <div class="cta-help">
      <hub-spot-form v-show="isFormActive" @closeHubSpot="onHelp" />
      <template>
        <v-btn
          :class="`cta-help__btn ${btnMinimized ? 'minimized' : ''}`"
          depressed
          @click="onHelp"
        >
          <v-img
            alt="Green Street Logo"
            class="shrink mt-1"
            contain
            src="../assets/message-white.svg"
            transition="scale-transition"
          />
          <p class="ml-2 mb-0 d-md-block d-none">Need A Hand?</p>
          <v-icon
            class="cta-help__btn-minimize"
            :small="true"
            @click="toggleMinimize"
          >
            mdi-window-minimize
          </v-icon>
        </v-btn>
      </template>
    </div>
    <div class="footer">
      <v-container fluid>
        <v-row>
          <v-col
            class="d-flex justify-start align-start pa-0"
            cols="12"
            md="9"
            sm="7"
          >
            <v-breadcrumbs class="float-left pl-0" :items="items" divider="">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item :href="item.to" class="text-capitalize">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <v-expansion-panels class="panel disclosure d-none d-md-block">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Disclosures
                  <template v-slot:actions>
                    <v-icon color="primary"> mdi-chevron-up </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-3">
                  <strong>News:</strong> Green Street’s News Vertical is not a
                  product of Green Street’s advisory business. It is an
                  independent business unit of Green Street. Green Street
                  maintains information barriers to ensure the independence of
                  the News unit and the research and advisory services provided
                  by Green Street. Green Street Advisors (UK) Ltd., doing
                  business as Green Street, is authorized and regulated by the
                  Financial Conducts Authority (FRN 482269). React News, a
                  wholly owned subsidiary of Green Street UK, is not part of
                  Green Street’s regulated business. React News operates behind
                  robust Information Barriers to ensure the independence of
                  React News and the research and advisory services provided by
                  Green Street. <br /><br />
                  <strong>Market Forecasts:</strong> The Green Street
                  Forecasting tool is an estimation of future events based on
                  market trends in historical data that have proved to provide
                  actionable insights during past market cycles. Green Street
                  makes no representations or warranties as to any future
                  performance of such metrics under any market cycles.
                  <br /><br />
                  <strong>AVM:</strong> AVM accuracy is substantiated by the
                  back-testing results of the methodology white paper. For more
                  details please request <br />
                  <a class="avm-link" :href="avmLink" target="_blank"
                    ><span>Green Street's AVM white paper</span></a
                  >. This is not part of the UK regulated business.
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <v-col cols="12" sm="5" md="3">
            <p
              class="
                footer__copy
                text-white text-md-right text-sm-right text-center
              "
            >
              All rights reserved | 2022 Green Street &copy;
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { SEGMENT_EVENTS } from '../constants';
import HubSpotForm from './HubSpotForm.vue';

export default {
  name: 'Footer',
  components: {
    HubSpotForm,
  },
  data: () => ({
    items: [
      {
        text: 'FAQ',
        disabled: false,
        to: '/faq',
      },
      {
        text: 'Contact Us',
        disabled: false,
        to: `${process.env.VUE_APP_MAIN_PLATFORM_LINK}contact-us`,
      },
    ],
    avmLink: `${process.env.VUE_APP_MAIN_PLATFORM_LINK}dashboard?region=NA`,
    btnMinimized: false,
    isFormActive: false,
  }),
  methods: {
    toggleMinimize(e = {}) {
      this.btnMinimized = !this.btnMinimized;
      e.stopPropagation?.();
    },
    onHelp() {
      this.isFormActive = !this.isFormActive;
      if (this.isFormActive) {
        window.analytics.track(SEGMENT_EVENTS.CLICKED_NEED_A_HAND);
      }
      // Maximize the button if minimized
      if (this.btnMinimized) {
        this.toggleMinimize();
        return;
      }
    },
  },
};
</script>

<style scoped>
.cta-help {
  padding: 0 33px;
  text-align: right;
  position: relative;
  z-index: 1;
  position: absolute;
  bottom: 5.5625rem;
  right: 0;
  left: 0;
}
.cta-help__btn {
  font-weight: bold;
  font-size: 0.75rem;
  line-height: 15px;
  color: #ffffff;
  width: 80px;
  height: 3rem !important;
  background-color: var(--v-primary-base) !important;
  text-transform: capitalize;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
  transition: transform 0.5s;
}
.cta-help__btn.minimized {
  transform: translateY(70%);
}
.cta-help__btn >>> .v-btn__content {
  position: absolute;
  height: 100%;
  width: 100%;
}
.cta-help__btn-minimize {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0.2rem;
}

.cta-help >>> .hs-form-field {
  text-align: left;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

@media (max-width: 600px) {
  .cta-help {
    bottom: 130px;
    padding: 0 16px;
  }
}
@media (min-width: 960px) {
  .cta-help__btn {
    width: 290px;
    height: 56px;
    padding: 1.75rem !important;
  }
  .cta-help__btn >>> .v-btn__content {
    position: inherit;
    height: auto;
    width: auto;
  }
  .cta-help__btn-minimize {
    display: none;
  }
}

.footer {
  background-color: #000;
  padding: 20px;
  z-index: 2;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
.footer >>> .v-breadcrumbs__item {
  color: #fff;
}
.footer .footer__copy {
  color: #fff;
  margin-bottom: 0;
  margin-top: 5px;
}
.footer >>> .v-expansion-panels {
  flex: 1;
  float: left;
}

.footer .panel >>> .v-expansion-panel {
  background-color: transparent;
  color: #fff;
}
.footer >>> .v-expansion-panel-header {
  min-height: 0;
  padding: 8px;
  padding-left: 10px;
  padding-top: 16px;
}
.footer >>> .v-expansion-panel-header__icon {
  margin-left: 0;
}
.footer >>> .disclosure {
  font-style: normal;
  font-size: 12px;
  line-height: 13px;
  letter-spacing: 0.2px;
  color: #d9dbe1;
}
.footer .footer__copy,
.footer >>> .v-breadcrumbs__item,
.footer >>> .v-expansion-panel-header {
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.2px;
  color: #d9dbe1;
}
.footer a.avm-link {
  color: #fff;
}
.app .v-expansion-panel-header > .v-expansion-panel-header__icon > i {
  color: #00b651 !important;
}
@media screen and (max-width: 600px) {
  .footer >>> .v-breadcrumbs {
    width: 100%;
    justify-content: center;
    border-bottom: 0.5px solid #ffffff;
  }
}
</style>
